// src/pagesMVP1010/ForgotPasswordPage.jsx
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../assets/styles/UpdatedWelcomePage.css';
import Blossom from '../assets/images/Blossom.webp';
import BloomPal_Logo from '../assets/images/BloomPal_MainLogo.png';
import api from '../utils/api';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const ensureCsrf = async () => {
    try {
      await api.get('/api/set-csrf/');
    } catch (e) {
      // CSRF setup failed, but continue anyway
    }
  };

  const pickError = (e, fallback) => {
    return (
      e?.response?.data?.email?.[0] ||
      e?.response?.data?.non_field_errors?.[0] ||
      e?.response?.data?.detail ||
      e?.response?.data?.error ||
      e?.message ||
      fallback
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setBusy(true);

    try {
      await ensureCsrf();
      await api.post('/api/auth/password/reset/', { email: email.trim() });
      setSuccess(true);
      setEmail(''); // Clear email on success
    } catch (err) {
      setError(pickError(err, 'Failed to send reset link. Please try again.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="wp-root">
      {/* Logo */}
      <div className="wp-logo-wrap">
        <img 
          src={BloomPal_Logo} 
          alt="BloomPal" 
          className="wp-logo" 
          onClick={() => navigate('/')}
          style={{ cursor: 'pointer' }}
        />
      </div>

      {/* Decorative bubbles */}
      <div className="wp-bubbles">
        <span className="b b1" />
        <span className="b b2" />
        <span className="b b3" />
        <span className="b b4" />
        <span className="b b5" />
      </div>

      <div className="wp-grid">
        {/* LEFT SIDE - Mascot and text */}
        <div className="wp-left">
          <img src={Blossom} alt="Blossom" className="wp-mascot" />
         
          <p className="wp-sub">
            Let's get you back on track.
          </p>
        </div>

        {/* RIGHT SIDE - Reset password card */}
        <div className="wp-right">
          <div className="wp-card">
            <h2 className="wp-card-title">Reset Password</h2>
            <p style={{ 
              textAlign: 'center', 
              color: '#60727e', 
              fontSize: '14px', 
              lineHeight: '1.5',
              margin: '0 0 24px 0' 
            }}>
              Enter the email associated with your account and we'll send you a magic link to reset your password.
            </p>

            {success && (
              <div style={{
                background: '#e8f5e9',
                color: '#2e7d32',
                border: '1px solid #a5d6a7',
                padding: '12px 16px',
                borderRadius: '10px',
                marginBottom: '16px',
                textAlign: 'center',
                fontWeight: '600'
              }} role="alert">
                Check your email!
              </div>
            )}

            {error && (
              <div style={{
                background: '#ffeaea',
                color: '#8a1f1f',
                border: '1px solid #f6b8b8',
                padding: '12px 16px',
                borderRadius: '10px',
                marginBottom: '16px'
              }} role="alert">
                {error}
              </div>
            )}

            <form className="wp-form" onSubmit={handleSubmit}>
              <input
                type="email"
                className="wp-input"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
                disabled={busy || success}
                style={{ marginBottom: '16px' }}
              />

              <button 
                type="submit" 
                className="wp-cta"
                disabled={busy || !email || success}
              >
                {busy ? 'Sending...' : 'Send Reset Link'}
              </button>

              <div style={{ 
                textAlign: 'center', 
                marginTop: '20px',
                fontSize: '14px'
              }}>
                <Link 
                  to="/" 
                  style={{ 
                    color: '#7a8ea0', 
                    textDecoration: 'none',
                    fontWeight: '600'
                  }}
                >
                  ← Back to Login
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;

